export interface EvaluacionItem {
  evaluador: string;
  fecha: string;
  scores: Record<string, string>;
  observaciones: string;
  ethicsFlag: string;
  recomendacion: string;
  decisionPropuesta?: 'aprobado' | 'correcciones' | 'no_pertinente' | '';
}

export interface ProyectoMock {
  codigo: string;
  titulo: string;
  investigador: string;
  email: string;
  area: string;
  categoria: string;
  estado: string;
  decision: string;
  etica: string;
  porcentaje: number;
  fechaRecepcion: string;
  fechaDecision: string;
  presupuesto: string;
  // Optional extended fields from form submission
  unidad?: string;
  telefono?: string;
  resumen?: string;
  objetivos?: string;
  diseno?: string;
  cronograma?: string;
  equipo?: string;
  financiamiento?: string;
  necesidad_etica?: string;
  justificacion_etica?: string;
  plan_publicacion?: string;
  fecha_inicio?: string;
  documentoNombre?: string;
  // Multi-evaluator fields (new)
  evaluaciones?: EvaluacionItem[];
  // Legacy single-evaluation fields (kept for backward compatibility)
  scores_eval?: Record<string, string>;
  observaciones_eval?: string;
  ethics_eval?: string;
}

export const proyectosMock: ProyectoMock[] = [
  {
    codigo: 'PRY-2026-001',
    titulo: 'Impacto de la telemedicina en zonas rurales',
    investigador: 'Dra. María Solano',
    email: 'maria.solano@universidad.edu',
    area: 'Ciencias de la Salud',
    categoria: 'Proyecto institucional',
    estado: 'En evaluación',
    decision: '—',
    etica: 'Sí',
    porcentaje: 0,
    fechaRecepcion: '2026-03-10',
    fechaDecision: '—',
    presupuesto: 'USD 12,000',
    resumen: 'Investigación sobre el impacto de la telemedicina en comunidades rurales con acceso limitado a servicios de salud presenciales.',
    objetivos: 'Evaluar la efectividad de plataformas de telemedicina en reducir barreras de acceso a salud en zonas rurales de difícil acceso.',
  },
  {
    codigo: 'TES-2026-002',
    titulo: 'Estrategias pedagógicas para inclusión educativa',
    investigador: 'Mg. Carmen Díaz',
    email: 'carmen.diaz@universidad.edu',
    area: 'Educación',
    categoria: 'Tesis',
    estado: 'Con correcciones',
    decision: 'Aprobable con correcciones',
    etica: 'No',
    porcentaje: 10,
    fechaRecepcion: '2026-01-18',
    fechaDecision: '2026-02-01',
    presupuesto: 'Autofinanciado',
    resumen: 'Análisis de estrategias pedagógicas inclusivas para estudiantes con necesidades educativas especiales en educación básica.',
    objetivos: 'Identificar y sistematizar estrategias pedagógicas efectivas para la inclusión de estudiantes con discapacidad visual en el aula regular.',
  },
];